import { generatePath, useOutletContext } from "react-router";

import GaiaPagination from "~/modules/app/components/GaiaPagination";

import { ProjectReviewVisitV2ObservationList } from "../../../../../components/ProjectReviewVisitV2ObservationList";
import { ProjectReviewVisitV2FunctionListRouteOutletContext } from "..";

export function PossibleFunctionsTab() {
    const { observations, page, pageSize, onPageChange } = useOutletContext<ProjectReviewVisitV2FunctionListRouteOutletContext>();

    const createLinkToObservation = (observation: NonNullable<(typeof observations)["data"]>[number]) => {
        return generatePath(`./${observation.featureId}`);
    };

    return (
        <>
            <ProjectReviewVisitV2ObservationList createTo={createLinkToObservation} observations={observations.data ?? []} />
            {(observations.data?.length ?? 0) > 0 && observations.queryInfo && (
                <GaiaPagination
                    sx={{ display: "flex", justifyContent: "center", paddingBlock: 2 }}
                    page={page}
                    onPageChange={onPageChange}
                    total={observations.queryInfo.paginationOption.total ?? 0}
                    pageSize={pageSize}
                />
            )}
        </>
    );
}
